export * from './lib/hosted-auth';

export { default as ImapIcon } from './lib/icon.svg';
export const imapName = 'IMAP';
